import { render, staticRenderFns } from "./BuyBoxFreeTrialSwiperOS.vue?vue&type=template&id=1e28365b&scoped=true"
import script from "./BuyBoxFreeTrialSwiperOS.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyBoxFreeTrialSwiperOS.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BuyBoxFreeTrialSwiperOS.vue?vue&type=style&index=0&id=1e28365b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e28365b",
  null
  
)

export default component.exports